"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Animate = exports.Root = void 0;

var _stylitas = require("@creditas/stylitas");

var _framerMotion = require("framer-motion");

const Root = _stylitas.styled.div`
  width: 100%;
  height: 100%;
`;
exports.Root = Root;
const Animate = (0, _stylitas.styled)(_framerMotion.motion.div)`
  width: 100%;
  height: 100%;
`;
exports.Animate = Animate;